import Raven from 'raven-js';
import { PureComponent } from 'react';
import { loadFontStylesheet, formatVariant, getVariantStyles } from 'ContentComponents/components/cmv2/fontPicker/utils';
import { Image } from 'foundations-components/transitional/components/Image';
import { FontOption } from './FontOption';
import { jsx as _jsx } from "react/jsx-runtime";
class GoogleFontOption extends PureComponent {
  constructor(props) {
    super(props);
    this.onSvgError = this.onSvgError.bind(this);
    this.state = {
      useFallback: false
    };
  }
  onSvgError() {
    const {
      font,
      variant
    } = this.props;
    Raven.captureMessage('Missing valid Google font SVG', {
      extra: {
        family: font.family,
        variant
      }
    });
    this.setState({
      useFallback: true
    });
  }
  renderFallback() {
    const {
      font,
      variant
    } = this.props;
    const {
      family
    } = font;
    loadFontStylesheet(family, font.variants);
    if (variant) {
      return /*#__PURE__*/_jsx(FontOption, {
        fontFamily: family,
        cssStyles: getVariantStyles(variant),
        children: formatVariant(variant)
      });
    }
    return /*#__PURE__*/_jsx(FontOption, {
      fontFamily: family,
      children: family
    });
  }
  render() {
    const {
      font,
      variant
    } = this.props;
    const {
      svgUrls = {}
    } = font;
    const svgUrl = variant ? svgUrls[variant] : svgUrls.main;
    if (this.state.useFallback || !svgUrl) {
      return this.renderFallback();
    }
    return /*#__PURE__*/_jsx(Image, {
      onError: this.onSvgError,
      src: `//${svgUrl}`
    });
  }
}
export default GoogleFontOption;